import React from "react";
import axios from "axios";
import { api } from "./link";
import Auth from "../Auth";
import { getProfile } from "../security/http";

class PasswordChange extends React.Component {
  state = { currentPassword: "", password: "", confirmPassword: "", error: "", saving: false };

  submit = async (event) => {
    event.preventDefault();
    const { currentPassword, password, confirmPassword } = this.state;
    if (password !== confirmPassword) {
      this.setState({ error: "Passwords do not match." });
      return;
    }
    if (password.length < 12 || new TextEncoder().encode(password).length > 72) {
      this.setState({ error: "Use at least 12 characters and no more than 72 UTF-8 bytes." });
      return;
    }
    this.setState({ saving: true, error: "" });
    try {
      await axios.post(`${api()}api/auth/password`, { currentPassword, password });
      Auth.SignOut();
      window.location.replace("#/Login");
    } catch (_) {
      this.setState({ saving: false, error: "Password could not be changed. Check your current password and try again." });
    }
  };

  render() {
    const profile = getProfile();
    const forced = profile && profile.passwordChangeRequired;
    return (
      <div className="login">
        <div className="overlay1">
          <div className="login">
            <div className="caerdlog">
              <h2 className="logintitle">{forced ? "Change your password" : "Update password"}</h2>
              <form className="formdata" onSubmit={this.submit}>
                {!forced && <label className="forminput lebelenter">Current password<input className="formModal" type="password" autoComplete="current-password" value={this.state.currentPassword} onChange={(event) => this.setState({ currentPassword: event.target.value })} required /></label>}
                <label className="forminput lebelenter">New password<input className="formModal" type="password" autoComplete="new-password" value={this.state.password} onChange={(event) => this.setState({ password: event.target.value })} required /></label>
                <label className="forminput lebelenter">Confirm new password<input className="formModal" type="password" autoComplete="new-password" value={this.state.confirmPassword} onChange={(event) => this.setState({ confirmPassword: event.target.value })} required /></label>
                <div className="dangerdemor" role="alert">{this.state.error}</div>
                <button className="btnapplsign mt-3" type="submit" disabled={this.state.saving}>{this.state.saving ? "Saving..." : "Change password"}</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PasswordChange;
